import React, { useEffect, useState } from "react";
import LoanPage from "../../../../../entities/DashboardPage/HRModule/Loan/LoanHome";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const Loan = () => {
  const [data,setData] = useState([]);
  const [page, setPage] = useState(1);
  const [period, setPeriod] = useState([]);
  const [tax, setTax] = useState([]);
  const [total, setTotal] = useState(1);
  const { showAlert } = useAlert();
  const [employeeData,setEmployeeData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getLoanList("","",page);
      getTaxYear();
    }
  },[page, permission])

  const getLoanList = async(text,sort,page) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getLoan(text,sort,page);
      if (result?.success) { 
        let loans = result?.data?.loans || [];
        
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.loan?.isView === true;
          const hasEditPermission = permission?.loan?.isEdit === true;
          
          if (hasEditPermission) {
            setTotal(result?.data?.total);
          } else if (hasViewPermission) {
            loans = loans.filter((loan) => loan?.employee?._id === employeeId || loan?.employee?.userId === employeeId);
            setTotal(loans.length);
          } else {
            loans = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.total);
        }
        
        setData(loans);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getStartPeriod = async(id) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getStartPeriod(id);
      if (result?.success) { 
        setPeriod(result?.data?.months);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getTaxYear = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getTaxYear();
      if (result?.success) { 
        setTax(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteLoan(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getLoanList();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleFilter = (text,sort) => {
    text ? getLoanList(text):sort ? getLoanList("",sort):null
  }

  const handleAddNewLoan = async (employeeId,date,repayment,loan,repaymentAmount,numberRepayments,des,remark,paymentMethod) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleLoan(employeeId,date,repayment,loan,repaymentAmount,numberRepayments,des,remark,paymentMethod);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        setOpen(false);
        getLoanList();
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateLoan = async(id,employeeId,date,repayment,loan,repaymentAmount,numberRepayments,des,remark,paymentMethod) =>{
    setLoading(true);
    try {
      const result = await AuthService.handleUpdateLoan(id,employeeId,date,repayment,loan,repaymentAmount,numberRepayments,des,remark,paymentMethod);
      if (result?.success) { 
        showAlert(result?.message,"success")
        setLoading(false);
        setOpen(false);
        getLoanList();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const SearchEmployee = async(text) =>{
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) { 
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.loanDownload();
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type:"application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <LoanPage permission={permission?.loan?.isEdit || role === "Admin" || role === "SuperAdmin"} role={role} page={page} handleDownload={handleDownload} getLoanList={getLoanList} getStartPeriod={getStartPeriod} total={total} tax={tax} period={period} handleUpdate={updateLoan} setPage={setPage} data={data} handleFilter={handleFilter} handleDelete={handleDelete} handleAdd={handleAddNewLoan} handleEmployee={SearchEmployee}loading={loading} employeeData ={employeeData} open={open} setOpen={setOpen}/>
  )
};
export default Loan;
